const translations = {
    attachFailed: 'Attach Chemical Mix Failed',
    connectionError: 'Connection Error',
    detachFailed: 'Detach Chemical Mix Failed'
};

export default translations;
